import React from "react";

export function ProfileProgress () {
    
    return (<>
    <div>ProfileProgress</div>
    </>);

}